import type {
  MenuLocation,
  RestaurantHours,
  RestaurantHoursException,
  RestaurantInfo,
} from '@/types/menuApi'

export interface EffectiveSchedule {
  hours?: RestaurantHours[]
  hoursExceptions?: RestaurantHoursException[]
  timeZone?: string
  lastOrderMinutes: number
}

export function getEffectiveSchedule(
  location?: MenuLocation | null,
  restaurant?: RestaurantInfo | null
): EffectiveSchedule {
  const locationHours = location?.hours
  const locationExceptions = location?.hours_exceptions

  return {
    hours: locationHours?.length ? locationHours : restaurant?.hours,
    hoursExceptions: locationExceptions?.length ? locationExceptions : restaurant?.hours_exceptions,
    timeZone: location?.timezone || restaurant?.timezone,
    lastOrderMinutes: location?.last_order_minutes_before_close ?? restaurant?.last_order_minutes_before_close ?? 0,
  }
}
